import React from 'react';
import { MdEmojiEvents } from 'react-icons/md';
import { PaginaDeportes } from '../_shared';
import TablaTorneos from './TablaTorneos';

const Torneos: React.FC = () => (
  <PaginaDeportes
    icon={MdEmojiEvents}
    titulo="Torneos Deportivos"
    subtitulo="Gestión de torneos, equipos, encuentros y tablas de posiciones"
  >
    <TablaTorneos />
  </PaginaDeportes>
);

export default Torneos;
